import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const SearchFilterButton = ({ onToggle, isOpen }) => {
  return (
    <>
      <div onClick={onToggle}>
        <span
          className={`${
            isOpen ? 'text-blue-500' : 'text-primary'
          } bs-xs:hover:text-blue-500 cursor-pointer`}
          data-toggle="class"
          data-class="move-right"
          data-target="#sticky-footer-wrap"
        >
          <i className="fa-regular fa-filter-list" />
          <span className="ml-1">Filter</span>
        </span>
      </div>

      {isOpen ? (
        <div className="relative w-full mx-auto ml-0 pl-0 bs-xs:hidden">
          <div className="fixed z-[1050] w-full bottom-0 h-20 bg-white p-4 left-0">
            <button
              className="bg-blue-700 text-white text-lg w-full h-full rounded"
              onClick={onToggle}
            >
              Show Results
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

SearchFilterButton.propTypes = {
  onToggle: PropTypes.func,
  isOpen: PropTypes.bool
};

export function SearchFilterPortal(props) {
  const root = document.getElementById('toggle-mobile-filter');
  if (!root) return null;

  return ReactDOM.createPortal(
    <SearchFilterButton {...props} />,
    document.getElementById('toggle-mobile-filter')
  );
}

export default SearchFilterButton;
